import { DesktopMainFooter, MobileMainFooter } from '@components/common/footer';

export default function MainFooter() {
  return (
    <footer className="sticky top-[100vh] w-full surface_secondary">
      <div className="mx-auto max-w-desktop-grid">
        <div className="hidden lg:block">
          <DesktopMainFooter />
        </div>
        <div className="lg:hidden">
          <MobileMainFooter />
        </div>
      </div>
    </footer>
  );
}
